import { useEffect, useState } from "react";
import { useFollowingQuery } from "queries";
import { IUserInfo } from "components/widgets/types";
import { UserListWidget } from "components/widgets/UserListWidget";

interface IUserListWidgetAlive {
  title: string;
  link: string;
  items: IUserInfo[];
  className?: string;
  list?: boolean;
  context: string | null;
}

export const UserListWidgetAlive = (props: IUserListWidgetAlive): JSX.Element => {
  const [following, setFollowing] = useState<string[]>([]);
  const [items, setItems] = useState<IUserInfo[]>(props.items);

  const query = useFollowingQuery({});

  useEffect(() => {
    if (query.status === "success" && query.data) {
      const ids = query.data.follows.map((user) => user.username);
      setFollowing(ids);
    }
  }, [query.status, query.data]);

  useEffect(() => {
    setItems((prev) => prev.map((n: IUserInfo): IUserInfo => ({
      ...n,
      following: following.indexOf(n.id) >= 0,
    })));
  }, [following]);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  return (
    <UserListWidget
      title={props.title}
      link={props.link}
      items={items}
      className={props.className}
      list={props.list}
    />
  );
};
